import api from "./axiosInstance";

/**
 * Fetch one complete page of a customer's passbook.
 */
export const getCustomerPassbook = (params = {}) => {
  return api.get("challans/passbook", {
    params
  });
};

/**
 * Fetch customer's product/balance summary.
 */
export const getCustomerPassbookSummary = (customerId) => {
  return api.get("challans/getPassbookSummary", {
    params: {
      id: customerId
    }
  });
};

/**
 * Calculate customer activity metrics from passbook data.
 * Fetches all pages of passbook to ensure accurate totals.
 */
export const getCustomerActivity = async ({
  customerId,
  customerName,
  customerEmail
}) => {
  // First page
  const firstResponse = await getCustomerPassbook({
    name: customerName,
    email: customerEmail,
    page: 0,
    size: 100
  });

  const firstData = firstResponse.data || {};

  let records = firstData.content || [];

  const totalPages = firstData.totalPages || 1;

  // Fetch remaining pages if required
  if (totalPages > 1) {
    const remainingRequests = [];

    for (let page = 1; page < totalPages; page++) {
      remainingRequests.push(
        getCustomerPassbook({
          name: customerName,
          email: customerEmail,
          page,
          size: 100
        })
      );
    }

    const responses = await Promise.all(remainingRequests);

    responses.forEach((response) => {
      records = [
        ...records,
        ...(response.data?.content || [])
      ];
    });
  }

  // Calculate delivered quantity
  const delivered = records.reduce((total, challan) => {
    return (
      total +
      (challan.items || []).reduce(
        (sum, item) =>
          sum + (Number(item.deliveredQty) || 0),
        0
      )
    );
  }, 0);

  // Calculate received quantity
  const received = records.reduce((total, challan) => {
    return (
      total +
      (challan.items || []).reduce(
        (sum, item) =>
          sum + (Number(item.receivedQty) || 0),
        0
      )
    );
  }, 0);

  /*
   * Every passbook record represents one challan/transaction.
   */
  const totalTransactions =
    firstData.totalElements ?? records.length;

  // Current balance
  let balance = 0;

  try {
    const summaryResponse =
      await getCustomerPassbookSummary(customerId);

    const summaryData =
      summaryResponse.data || [];

    balance = summaryData.reduce(
      (sum, item) =>
        sum + (Number(item.closingBalance) || 0),
      0
    );
  } catch (error) {
    console.error(
      `Failed to fetch balance for customer ${customerId}`,
      error
    );
  }

  return {
    delivered,
    received,
    totalTransactions,
    balance
  };
};
